import React, { useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import logo from '../../assets/icons/logo-yellow.svg';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import menuIcon from '../../assets/icons/menu.svg';

const NavbarComponent = () => {
  const [iscolored, setIsColored] = useState('');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      setIsColored('true');
    } else {
      setIsColored('');
    }
  });

  return (
    <StyledNavbar
      iscolored={iscolored}
      collapseOnSelect
      expand="xl"
      fixed="top"
    >
      <Container>
        <Navbar.Brand href="https://energo.app/">
          <Image src={logo} />
        </Navbar.Brand>
        <NavBarToggle
          aria-controls="responsive-navbar-nav"
          onClick={() => setIsColored('true')}
        />
        <Navbar.Collapse id="responsive-navbar-nav">
          <StyledNav className="ms-auto">
            {/* <NavBarLink to="conditions">
              <StyledNavLink>Условия</StyledNavLink>
            </NavBarLink>
            <NavBarLink to="equipment">
              <StyledNavLink>Наше оборудование</StyledNavLink>
            </NavBarLink> */}
            <NavBarLink to="faq">
              <StyledNavLink>Частые вопросы</StyledNavLink>
            </NavBarLink>
            <NavBarLink to="advantages">
              <StyledNavLink>Преимущества</StyledNavLink>
            </NavBarLink>
            <NavBarLink to="about">
              <StyledNavLink>О нас</StyledNavLink>
            </NavBarLink>
            <NavBarLink to="contact">
              <StyledNavLink>Контакты</StyledNavLink>
            </NavBarLink>
          </StyledNav>
          <Link to="contact-form">
            <Button>Стать партнером</Button>
          </Link>
        </Navbar.Collapse>
      </Container>
    </StyledNavbar>
  );
};

const StyledNav = styled(Nav)`
  & .show {
    height: 100%;
  }
`;

const NavBarLink = styled(Link)`
  margin: 5px 0;
`;

const NavBarToggle = styled(Navbar.Toggle)`
  border: none;
  outline: none;
  box-shadow: none;
  color: transparent;
  & span {
    background-image: url(${menuIcon});
  }
`;

const StyledNavbar = styled(Navbar)<{ iscolored: boolean }>`
  background-color: ${(props) =>
    props.iscolored ? 'rgba(38, 41, 45, 0.9)' : 'transparent'};
  transition: 1s ease;
`;

const Button = styled.button`
  border: 2px solid #ffdc00;
  color: #ffdc00;
  border-radius: 8px;
  width: 167px;
  height: 40px;
  font-size: 16px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.2);
  margin: 5px 0;
  &:hover {
    color: #26292d;
    background: #fff;
  }
`;

const StyledNavLink = styled.span`
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  margin-right: 40px;
  padding-right: 0 !important;
  padding-left: 0 !important;
  padding: 0;
  border-bottom: 1px solid transparent;
  cursor: pointer;
  &:focus {
    color: #fff;
  }
  &:hover {
    color: #fff;
    border-bottom: 1px solid #fff;
  }
`;

export default NavbarComponent;
